import { Table, Modal, Input, Grid } from 'antd';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import axios from 'axios';
import { SearchOutlined } from '@ant-design/icons';
import { API_ENDPOINTS } from '../../../assets/api/endpoints';
import { AdminsColumns } from '../adminsColumns';
import { useConfigurationContext } from '../../../store/configurationContext';
import { StyledPagination } from '../../../components/table.style';
const AdminUserListTable = ({
	showClosePopup,
	setShowClosePopup,
	handelAssign,
}: {
	showClosePopup: boolean;
	setShowClosePopup: (value: boolean) => void;
	handelAssign: (userId: number) => void;
}) => {
	const { t } = useTranslation();
	const [adminLoading, setadminLoading] = useState(false);
	const [adminUsers, setadminUsers] = useState([]);
	const [userId, setUserId] = useState<number>(0);
	const [sortBy, setSortBy] = useState<string>('name-asc');
	const [pagesize, setPageSize] = useState(10);
	const [page, setPage] = useState(0);
	const [totalElements, setTotalElements] = useState(0);
	const [searchTerm, setSearchTerm] = useState('');
	const { lg } = Grid.useBreakpoint();
	const { configurationState } = useConfigurationContext();
	const themeColor = configurationState.find((item) => item.configKey === 'theme_color')?.value || '';
	const secondary_color = configurationState.find((item) => item.configKey === 'secondary_color')?.value || '';

	useEffect(() => {
		setadminLoading(true);
		axios
			.get(`${API_ENDPOINTS.getAdminUser}`)
			.then((res) => {
				const sortedData = res.data
					.sort((a: any, b: any) => {
						switch (sortBy) {
							case 'name-asc':
								return a.fullName.localeCompare(b.fullName);
							case 'name-desc':
								return b.fullName.localeCompare(a.fullName);
							case 'canHandleRequests-asc':
								return a.canHandleRequests - b.canHandleRequests;
							case 'canHandleRequests-desc':
								return b.canHandleRequests - a.canHandleRequests;
							case 'activeTask-asc':
								return a.activeTask - b.activeTask;
							case 'activeTask-desc':
								return b.activeTasks - a.activeTasks;
							default:
								return 0;
						}
					})
					.filter((item: any) => item.fullName.toLowerCase().includes(searchTerm.toLowerCase()));
				setadminUsers(sortedData);
				setTotalElements(res.data.length);
			})
			.catch((err) => console.error(err))
			.finally(() => setadminLoading(false));
	}, [sortBy, searchTerm, showClosePopup]);

	const assign = () => {
		handelAssign(userId);
	};

	const getRowClassName = (record: {
		id: number;
		fullName: string;
		canHandleRequests: boolean;
		activeTasks: number;
	}) => {
		return userId === record.id ? 'selected-row' : '';
	};

	return (
		<Modal
			title={<div className='flex justify-center'>{t<string>('admin')}</div>}
			open={showClosePopup}
			onCancel={() => setShowClosePopup(false)}
			footer={null}
			width={640}
			zIndex={1000}
		>
			<div className='user-list-container min-h-[560px] flex flex-col justify-between'>
				<div className=' pt-[20px] bg-white'>
					<div className='flex items-center my-2 justify-end'>
						<Input
							className='border-none h-10 bg-[#F5F5F5] search-input w-[200px]'
							disabled={adminLoading}
							placeholder={t<string>('searchAdmin')}
							value={searchTerm}
							onChange={(e) => {
								setSearchTerm(e.target.value);
							}}
							size='large'
							prefix={<SearchOutlined className='mr-2' />}
						/>
					</div>
					<StyledPagination bgColor={themeColor} color={secondary_color}>
						<Table
							onRow={(record: { id: number; fullName: string; canHandleRequests: boolean; activeTasks: number }) => ({
								onClick: (event: React.MouseEvent<HTMLElement>) => {
									setUserId(record.id);
								},
							})}
							columns={AdminsColumns({ isMobile: !lg, t: t, sortBy, setSortBy })}
							dataSource={adminUsers}
							pagination={{
								pageSize: pagesize,
								total: totalElements,
								showSizeChanger: false,
								onChange: (pageIndex) => setPage(pageIndex - 1),
							}}
							loading={adminLoading}
							tableLayout='auto'
							rowClassName={getRowClassName}
						/>
					</StyledPagination>
				</div>
				<div className='flex justify-end'>
					<button className='assignBtn' onClick={assign}>
						{t<string>('assign')}
					</button>
				</div>
			</div>
		</Modal>
	);
};

export default AdminUserListTable;
